module.exports = __webpack_public_path__ + "static/assets/c831582f5b68ee98b2afd28d62865b94.svg";